import Startup from './Startup';

// Wait for the Elementor Frontend to load
jQuery( window ).on( 'elementor/frontend/init', () => {

	const widgetIdentifier = 'algolia-catalog';

	// Wait for the widget to be ready
	elementorFrontend.hooks.addAction( 'frontend/element_ready/widget', ( $scope ) => {

		// Check for the correct type of widget
		const widgetType = $scope.data( 'widget_type' );

		if ( widgetType && $scope.data( 'widget_type' ).indexOf( widgetIdentifier ) > -1 ){

			// The widget is ready, now startup
			new Startup().run($scope);
		}

	} );
});
